export default{

    NAME: 'ufp-react-redux-router3'

}
